import { apiUrl } from 'config/api';
import { get } from './common';
import { Tag } from '../models/interfaces/Tag';

export const getTags = async () => {
  return get<Tag[]>(`${apiUrl}/v1/tags`);
};

export default getTags;
